module.exports = __webpack_public_path__ + "static/media/Amazon-Thumbnail.d62f761a.png";